import { render, staticRenderFns } from "./MlbbObsPage.vue?vue&type=template&id=309f45ca"
import script from "./MlbbObsPage.vue?vue&type=script&lang=js"
export * from "./MlbbObsPage.vue?vue&type=script&lang=js"
import style0 from "./MlbbObsPage.vue?vue&type=style&index=0&id=309f45ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports